module.exports = __webpack_public_path__ + "static/img/aboutysj_m.b0d23bea.jpg";